import React, { useState, useEffect, useContext } from 'react';

import styles from './NovoPedido.module.css';

import { useNavigate } from 'react-router-dom';

import {
  FiTrash2,
  FiMinus,
  FiPlus,
  FiArrowLeft,
  FiArrowRight,
  FiSearch
} from 'react-icons/fi';

import { MdRestaurantMenu } from 'react-icons/md';

import FooterOpcoes from '../../cliente/components/FooterOpcoes';

import HeaderPageEquipe from '../components/HeaderPageEquipe';

import { CategoriasContext } from '../../../shared/contexts/CategoriasContext';
import { EstabelecimentosContext } from '../../../shared/contexts/EstabelecimentosContext';

function NovoPedido() {
  const navigate = useNavigate();

  const nomeEstabelecimento = localStorage.getItem('nomeEstabelecimento');
  const estabelecimentoId = localStorage.getItem('estabelecimento_id');

  const { categorias } = useContext(CategoriasContext);
  const { estabelecimentos } = useContext(EstabelecimentosContext);

  // Pizzaria com mais de um sabor: só disponível pra estabelecimento do
  // segmento 'pizzaria' (ver CriarEstabelecimento.jsx) e produtos da
  // categoria padrão "Pizzas" (ver sql/categorias_padrao.sql).
  const estabelecimentoAtual = estabelecimentos.find(
    (e) => String(e.id_estabelecimento) === String(estabelecimentoId)
  );
  const isPizzaria = estabelecimentoAtual?.segmento === 'pizzaria';
  const categoriaPizza = categorias.find((c) => c.nome_categoria === 'Pizzas');
  const MAX_SABORES_PIZZA = 3;

  // null = modal fechado. Passo 'quantidade' pergunta quantos sabores;
  // 'sabores' mostra a lista de sabores pra marcar.
  const [montarPizza, setMontarPizza] = useState(null);

  const [categoriaSelecionada, setCategoriaSelecionada] = useState(null);

  const [produtos, setProdutos] = useState([]);

  const [mesas, setMesas] = useState([]);

  const [idMesaSelecionada, setIdMesaSelecionada] = useState(() => {
    const raw = localStorage.getItem('id_mesa');

    return raw && raw !== 'null' && raw !== 'undefined'
      ? Number(raw)
      : null;
  });

  const [carrinho, setCarrinho] = useState([]);

  const [formaPagamento, setFormaPagamento] = useState('');

  const [carrinhoAberto, setCarrinhoAberto] = useState(false);

  const [loading, setLoading] = useState(false);

  const [sucesso, setSucesso] = useState(null);

  // NOVO: estado do filtro por nome do item
  const [filtroNomeItem, setFiltroNomeItem] = useState('');

  // Buscar produtos do estabelecimento
  useEffect(() => {
    const fetchProdutos = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL;

        const url = estabelecimentoId
          ? `${API_URL}/cadastroprodutos?id_estabelecimento=${estabelecimentoId}`
          : `${API_URL}/cadastroprodutos`;

        const response = await fetch(url);

        if (!response.ok) {
          throw new Error('Erro ao buscar produtos');
        }

        const data = await response.json();

        setProdutos(data);
      } catch (error) {
        console.error('Erro ao buscar produtos:', error);
      }
    };

    fetchProdutos();
  }, [estabelecimentoId]);

  // Buscar mesas do estabelecimento
  useEffect(() => {
    const fetchMesas = async () => {
      try {
        const API_URL = process.env.REACT_APP_API_URL;
        const token = localStorage.getItem('token');

        const response = await fetch(`${API_URL}/mesas`, {
          headers: {
            Authorization: `Bearer ${token}`
          }
        });

        if (response.ok) {
          const data = await response.json();

          setMesas(data);
        }
      } catch (error) {
        console.error('Erro ao buscar mesas:', error);
      }
    };

    fetchMesas();
  }, []);

  const selecionarMesa = (id) => {
    setIdMesaSelecionada(id);

    if (id === null) {
      localStorage.removeItem('id_mesa');
    } else {
      localStorage.setItem('id_mesa', id);
    }
  };

  const mesaAtual = mesas.find(
    (m) => m.id_mesa === idMesaSelecionada
  );

  const mesaLabel = mesaAtual
    ? `Mesa ${String(
        mesaAtual.numero_da_mesa ?? mesaAtual.id_mesa
      ).padStart(2, '0')}`
    : 'Balcão';

  // Produtos filtrados
  const produtosFiltrados = produtos
    // Apenas produtos disponíveis
    .filter(
      (p) =>
        p.disponivel?.toLowerCase() === 'sim'
    )

    // Filtro por categoria
    .filter(
      (p) =>
        categoriaSelecionada
          ? p.id_categoria === categoriaSelecionada
          : true
    )

    // NOVO: filtro por nome_item
    .filter((p) => {
      const nomeProduto = String(p.nome_item || '').toLowerCase().trim();
      const busca = filtroNomeItem.toLowerCase().trim();

      return nomeProduto.includes(busca);
    });

  const getQuantidadeNoCarrinho = (id_item) => {
    const item = carrinho.find(
      (i) => i.id_item === id_item
    );

    return item ? item.quantidade : 0;
  };

  const adicionarAoCarrinho = (produto) => {
    setCarrinho((prev) => {
      const existente = prev.find(
        (item) => item.id_item === produto.id_item
      );

      if (existente) {
        return prev.map((item) =>
          item.id_item === produto.id_item
            ? {
                ...item,
                quantidade: item.quantidade + 1
              }
            : item
        );
      }

      return [
        ...prev,
        {
          id_item: produto.id_item,
          nome: produto.nome_item,
          preco: parseFloat(produto.preco),
          imagem: produto.imagem,
          quantidade: 1,
          id_estabelecimento: produto.id_estabelecimento,
          observacao: ''
        }
      ];
    });
  };

  // Produto de categoria Pizzas: se for pizzaria, abre o modal de sabores em
  // vez de adicionar direto. O produto clicado já entra como o 1º sabor —
  // o modal só pergunta quantos sabores no total e pede os que faltam.
  // Qualquer outro produto segue o fluxo normal.
  const handleAdicionarProduto = (produto) => {
    const ehPizza = isPizzaria && categoriaPizza && produto.id_categoria === categoriaPizza.id_categoria;

    if (ehPizza) {
      setMontarPizza({ passo: 'quantidade', maxSabores: null, saboresSelecionados: [produto] });
      return;
    }

    adicionarAoCarrinho(produto);
  };

  const escolherQuantidadeSabores = (qtd) => {
    // 1 sabor = só o produto já clicado, sem precisar escolher mais nada.
    if (qtd === 1) {
      const produtoUnico = montarPizza?.saboresSelecionados?.[0];
      setMontarPizza(null);
      if (produtoUnico) adicionarAoCarrinho(produtoUnico);
      return;
    }

    setMontarPizza((prev) => ({ ...prev, passo: 'sabores', maxSabores: qtd }));
  };

  const alternarSaborSelecionado = (produto) => {
    setMontarPizza((prev) => {
      const jaSelecionado = prev.saboresSelecionados.some((p) => p.id_item === produto.id_item);

      if (jaSelecionado) {
        return { ...prev, saboresSelecionados: prev.saboresSelecionados.filter((p) => p.id_item !== produto.id_item) };
      }

      if (prev.saboresSelecionados.length >= prev.maxSabores) {
        return prev;
      }

      return { ...prev, saboresSelecionados: [...prev.saboresSelecionados, produto] };
    });
  };

  const confirmarMontagemPizza = () => {
    const sabores = montarPizza?.saboresSelecionados || [];
    if (sabores.length === 0) return;

    if (sabores.length === 1) {
      adicionarAoCarrinho(sabores[0]);
      setMontarPizza(null);
      return;
    }

    // Preço da pizza multi-sabor = preço do sabor mais caro escolhido.
    const precoPizza = Math.max(...sabores.map((s) => parseFloat(s.preco)));
    const nomePizza = sabores.map((s) => s.nome_item).join(' + ');
    const idComposto = `pizza-${sabores.map((s) => s.id_item).sort((a, b) => a - b).join('-')}-${Date.now()}`;

    setCarrinho((prev) => [
      ...prev,
      {
        id_item: idComposto,
        nome: nomePizza,
        preco: precoPizza,
        imagem: null,
        quantidade: 1,
        id_estabelecimento: estabelecimentoId,
        observacao: '',
        sabores: sabores.map((s) => ({
          id_produto: s.id_item,
          nome_item: s.nome_item,
          preco: parseFloat(s.preco)
        }))
      }
    ]);

    setMontarPizza(null);
  };

  const atualizarObservacao = (id_item, observacao) => {
    setCarrinho((prev) =>
      prev.map((item) =>
        item.id_item === id_item
          ? {
              ...item,
              observacao
            }
          : item
      )
    );
  };

  const alterarQuantidade = (id_item, delta) => {
    setCarrinho((prev) => {
      const atual = prev.find(
        (item) => item.id_item === id_item
      );

      if (!atual) {
        return prev;
      }

      const novaQtd = atual.quantidade + delta;

      if (novaQtd <= 0) {
        return prev.filter(
          (item) => item.id_item !== id_item
        );
      }

      return prev.map((item) =>
        item.id_item === id_item
          ? {
              ...item,
              quantidade: novaQtd
            }
          : item
      );
    });
  };

  const removerDoCarrinho = (id_item) => {
    setCarrinho((prev) =>
      prev.filter(
        (item) => item.id_item !== id_item
      )
    );
  };

  const totalCarrinho = carrinho.reduce(
    (acc, item) =>
      acc + item.preco * item.quantidade,
    0
  );

  const totalItens = carrinho.reduce(
    (acc, item) =>
      acc + item.quantidade,
    0
  );

  const criarPedido = async () => {
    if (carrinho.length === 0) {
      alert(
        'Adicione itens ao pedido antes de finalizar.'
      );

      return;
    }

    if (!formaPagamento) {
      alert(
        'Selecione a forma de pagamento.'
      );

      return;
    }

    setLoading(true);

    try {
      const API_URL =
        process.env.REACT_APP_API_URL;

      const token =
        localStorage.getItem('token');

      const pedido = {
        id_estabelecimento:
          Number(estabelecimentoId),

        id_cliente: null,

        forma_de_pagamento:
          formaPagamento,

        total: totalCarrinho,

        tipo_entrega: 'Agora',

        data_agendada: null,

        hora_agendada: null,

        id_mesa: idMesaSelecionada,

        // Pedido lançado numa mesa é do garçom;
        // sem mesa selecionada é balcão.
        origem_pedido: idMesaSelecionada
          ? 'garcom'
          : 'balcão',

        itens: carrinho.map((item) => ({
          id_estabelecimento:
            Number(estabelecimentoId),

          // Pizza com mais de um sabor não tem um produto único — vai em
          // "sabores" abaixo, e o backend ignora id_produto nesse caso.
          id_produto: item.sabores ? null : item.id_item,

          quantidade: item.quantidade,

          total_item:
            item.preco * item.quantidade,

          observacao:
            item.observacao?.trim() ||
            'Sem observação',

          nome_item: item.nome,

          sabores: item.sabores || undefined
        }))
      };

      const response = await fetch(
        `${API_URL}/fecharpedido`,
        {
          method: 'POST',

          headers: {
            'Content-Type':
              'application/json',

            Authorization: `Bearer ${token}`
          },

          body: JSON.stringify(pedido)
        }
      );

      const result =
        await response.json();

      if (response.ok) {
        setSucesso({
          id_pedido:
            result.pedido?.id_pedido,

          numero_pedido:
            result.pedido?.numero_pedido,

          codigo_entrega:
            result.codigo_entrega,

          total: totalCarrinho,

          formaPagamento
        });

        setCarrinho([]);

        setFormaPagamento('');

        setCarrinhoAberto(false);
      } else {
        alert(
          `Erro: ${
            result.message ||
            'Erro ao criar pedido'
          }`
        );
      }
    } catch (error) {
      console.error(
        'Erro ao criar pedido:',
        error
      );

      alert(
        'Erro ao criar pedido. Tente novamente.'
      );
    } finally {
      setLoading(false);
    }
  };

  // Tela de sucesso
  if (sucesso) {
    return (
      <div className={styles.sucessoContainer}>
        <div className={styles.sucessoCard}>
          <div className={styles.sucessoIcone}>
            ✓
          </div>

          <h2>Pedido Criado!</h2>

          <div className={styles.sucessoInfo}>
            <p>
              Pedido{' '}
              <strong>
                #
                {sucesso.numero_pedido ??
                  sucesso.id_pedido}
              </strong>
            </p>

            <p>
              Total:{' '}
              <strong>
                R$ {sucesso.total.toFixed(2)}
              </strong>
            </p>

            <p>
              Pagamento:{' '}
              <strong>
                {sucesso.formaPagamento}
              </strong>
            </p>
          </div>

          <button
            className={styles.btnNovoPedido}
            onClick={() =>
              setSucesso(null)
            }
          >
            Novo Pedido
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className={styles.pagina}>
      {/* Header */}
      <HeaderPageEquipe
        nomeEstabelecimento={
          nomeEstabelecimento
        }
        nomePage="Novo Pedido"
      />

      {/* Mesas */}
      <div className={styles.mesaPills}>
        {mesas
          .filter(
            (mesa) =>
              mesa.ativa !== false
          )
          .map((mesa) => (
            <button
              key={mesa.id_mesa}
              className={`${styles.mesaPill} ${
                idMesaSelecionada ===
                mesa.id_mesa
                  ? styles.mesaPillAtiva
                  : ''
              }`}
              onClick={() =>
                selecionarMesa(
                  mesa.id_mesa
                )
              }
            >
              Mesa{' '}
              {String(
                mesa.numero_da_mesa ??
                  mesa.id_mesa
              ).padStart(2, '0')}
            </button>
          ))}

        <button
          className={`${styles.mesaPill} ${
            idMesaSelecionada === null
              ? styles.mesaPillAtiva
              : ''
          }`}
          onClick={() =>
            selecionarMesa(null)
          }
        >
          Balcão
        </button>
      </div>

      {/* Categorias */}
      <div className={styles.categoriaTabs}>
        <button
          className={`${styles.categoriaTab} ${
            categoriaSelecionada === null
              ? styles.categoriaTabAtiva
              : ''
          }`}
          onClick={() =>
            setCategoriaSelecionada(null)
          }
        >
          todos
        </button>

        {categorias.map((cat) => (
          <button
            key={cat.id_categoria}
            className={`${styles.categoriaTab} ${
              categoriaSelecionada ===
              cat.id_categoria
                ? styles.categoriaTabAtiva
                : ''
            }`}
            onClick={() =>
              setCategoriaSelecionada(
                cat.id_categoria
              )
            }
          >
            {cat.nome_categoria?.toLowerCase()}
          </button>
        ))}
      </div>

      {/* NOVO: Campo de busca por nome_item */}
      <div className={styles.filtroNomeItem}>
        <FiSearch
          className={styles.filtroNomeIcone}
          size={18}
        />

        <input
          type="text"
          placeholder="Filtrar por nome do item..."
          value={filtroNomeItem}
          onChange={(e) =>
            setFiltroNomeItem(
              e.target.value
            )
          }
        />

        {filtroNomeItem && (
          <button
            type="button"
            className={styles.filtroNomeLimpar}
            onClick={() =>
              setFiltroNomeItem('')
            }
            aria-label="Limpar busca"
          >
            ×
          </button>
        )}
      </div>

      {/* Lista de Produtos */}
      <div className={styles.produtosLista}>
        {produtosFiltrados.length > 0 ? (
          produtosFiltrados.map(
            (produto) => {
              const qtd =
                getQuantidadeNoCarrinho(
                  produto.id_item
                );

              return (
                <div
                  key={produto.id_item}
                  className={`${
                    styles.produtoLinha
                  } ${
                    qtd > 0
                      ? styles.produtoLinhaAtiva
                      : ''
                  }`}
                >
                  {produto.imagem ? (
                    <img
                      src={produto.imagem}
                      alt={
                        produto.nome_item
                      }
                      className={
                        styles.produtoImgMini
                      }
                    />
                  ) : (
                    <span
                      className={`${styles.produtoImgMini} ${styles.produtoImgPlaceholder}`}
                    >
                      <MdRestaurantMenu />
                    </span>
                  )}

                  <div
                    className={
                      styles.produtoInfoLista
                    }
                  >
                    <h4
                      className={
                        styles.produtoNomeLista
                      }
                    >
                      {produto.nome_item}
                    </h4>

                    <span
                      className={
                        styles.produtoPrecoLista
                      }
                    >
                      R${' '}
                      {parseFloat(
                        produto.preco
                      ).toFixed(2)}
                    </span>
                  </div>

                  {qtd > 0 ? (
                    <div
                      className={
                        styles.produtoQtdControle
                      }
                    >
                      <button
                        className={
                          styles.produtoQtdBtn
                        }
                        onClick={() =>
                          alterarQuantidade(
                            produto.id_item,
                            -1
                          )
                        }
                      >
                        <FiMinus
                          size={14}
                        />
                      </button>

                      <span
                        className={
                          styles.produtoQtdValor
                        }
                      >
                        {qtd}
                      </span>

                      <button
                        className={
                          styles.produtoQtdBtn
                        }
                        onClick={() =>
                          alterarQuantidade(
                            produto.id_item,
                            1
                          )
                        }
                      >
                        <FiPlus
                          size={14}
                        />
                      </button>
                    </div>
                  ) : (
                    <button
                      className={
                        styles.produtoAddBtn
                      }
                      onClick={() =>
                        handleAdicionarProduto(
                          produto
                        )
                      }
                    >
                      <FiPlus size={18} />
                    </button>
                  )}
                </div>
              );
            }
          )
        ) : (
          <p
            className={
              styles.semProdutos
            }
          >
            Nenhum produto encontrado.
          </p>
        )}
      </div>

      {/* Modal de montagem de pizza com múltiplos sabores */}
      {montarPizza && (() => {
        const restantesSabores = Math.max((montarPizza.maxSabores || 0) - montarPizza.saboresSelecionados.length, 0);
        return (
        <div
          className={styles.carrinhoOverlay}
          onClick={() => setMontarPizza(null)}
        >
          <div
            className={styles.carrinhoPanel}
            onClick={(e) => e.stopPropagation()}
          >
            <div className={styles.carrinhoHeader}>
              <h3>
                {montarPizza.passo === 'quantidade'
                  ? 'Quantos sabores no total?'
                  : `Falta${restantesSabores === 1 ? '' : 'm'} escolher ${restantesSabores} sabor${restantesSabores === 1 ? '' : 'es'}`}
              </h3>

              <button
                className={styles.fecharCarrinho}
                onClick={() => setMontarPizza(null)}
              >
                ✕
              </button>
            </div>

            {montarPizza.passo === 'quantidade' ? (
              <div style={{ display: 'flex', gap: 12, padding: '16px 0' }}>
                {Array.from({ length: MAX_SABORES_PIZZA }, (_, i) => i + 1).map((qtd) => (
                  <button
                    key={qtd}
                    className={styles.btnCriarPedido}
                    onClick={() => escolherQuantidadeSabores(qtd)}
                  >
                    {qtd} {qtd === 1 ? 'sabor' : 'sabores'}
                  </button>
                ))}
              </div>
            ) : (
              <>
                {montarPizza.saboresSelecionados.length > 0 && (
                  <p style={{ margin: '4px 0 0', fontSize: 13, color: '#555' }}>
                    Já escolhido{montarPizza.saboresSelecionados.length === 1 ? '' : 's'}: {montarPizza.saboresSelecionados.map((s) => s.nome_item).join(', ')}
                  </p>
                )}

                <div style={{ display: 'flex', flexDirection: 'column', gap: 8, padding: '12px 0', maxHeight: '50vh', overflowY: 'auto' }}>
                  {produtos
                    .filter(
                      (p) =>
                        p.id_categoria === categoriaPizza?.id_categoria &&
                        p.disponivel?.toLowerCase() === 'sim'
                    )
                    .map((sabor) => {
                      const selecionado = montarPizza.saboresSelecionados.some((s) => s.id_item === sabor.id_item);
                      const limiteAtingido = !selecionado && montarPizza.saboresSelecionados.length >= montarPizza.maxSabores;

                      return (
                        <label
                          key={sabor.id_item}
                          style={{
                            display: 'flex',
                            alignItems: 'center',
                            gap: 10,
                            opacity: limiteAtingido ? 0.5 : 1
                          }}
                        >
                          <input
                            type="checkbox"
                            checked={selecionado}
                            disabled={limiteAtingido}
                            onChange={() => alternarSaborSelecionado(sabor)}
                          />
                          <span>{sabor.nome_item}</span>
                          <span style={{ marginLeft: 'auto' }}>
                            R$ {parseFloat(sabor.preco).toFixed(2)}
                          </span>
                        </label>
                      );
                    })}
                </div>

                <button
                  className={styles.btnCriarPedido}
                  disabled={montarPizza.saboresSelecionados.length !== montarPizza.maxSabores}
                  onClick={confirmarMontagemPizza}
                >
                  Adicionar pizza
                </button>
              </>
            )}
          </div>
        </div>
        );
      })()}

      {/* Painel do Carrinho */}
      {carrinhoAberto && (
        <div
          className={
            styles.carrinhoOverlay
          }
          onClick={() =>
            setCarrinhoAberto(false)
          }
        >
          <div
            className={
              styles.carrinhoPanel
            }
            onClick={(e) =>
              e.stopPropagation()
            }
          >
            <div
              className={
                styles.carrinhoHeader
              }
            >
              <h3>
                Itens do Pedido
              </h3>

              <button
                className={
                  styles.fecharCarrinho
                }
                onClick={() =>
                  setCarrinhoAberto(
                    false
                  )
                }
              >
                ✕
              </button>
            </div>

            {carrinho.length === 0 ? (
              <p
                className={
                  styles.carrinhoVazio
                }
              >
                Nenhum item adicionado.
              </p>
            ) : (
              <div
                className={
                  styles.carrinhoItens
                }
              >
                {carrinho.map((item) => (
                  <div
                    key={item.id_item}
                    className={
                      styles.carrinhoItem
                    }
                  >
                    <div
                      className={
                        styles.carrinhoItemLinha
                      }
                    >
                      <div
                        className={
                          styles.carrinhoItemInfo
                        }
                      >
                        <span
                          className={
                            styles.carrinhoItemNome
                          }
                        >
                          {item.nome}
                        </span>

                        {item.sabores && (
                          <span style={{ fontSize: 12, color: '#777' }}>
                            Pizza {item.sabores.length} sabores
                          </span>
                        )}

                        <span
                          className={
                            styles.carrinhoItemPreco
                          }
                        >
                          R${' '}
                          {(
                            item.preco *
                            item.quantidade
                          ).toFixed(2)}
                        </span>
                      </div>

                      <div
                        className={
                          styles.carrinhoItemAcoes
                        }
                      >
                        <button
                          onClick={() =>
                            alterarQuantidade(
                              item.id_item,
                              -1
                            )
                          }
                        >
                          <FiMinus />
                        </button>

                        <span>
                          {item.quantidade}
                        </span>

                        <button
                          onClick={() =>
                            alterarQuantidade(
                              item.id_item,
                              1
                            )
                          }
                        >
                          <FiPlus />
                        </button>

                        <button
                          className={
                            styles.btnRemover
                          }
                          onClick={() =>
                            removerDoCarrinho(
                              item.id_item
                            )
                          }
                        >
                          <FiTrash2 />
                        </button>
                      </div>
                    </div>

                    <input
                      type="text"
                      className={
                        styles.carrinhoItemObservacao
                      }
                      placeholder="Observação (ex: sem cebola, ponto da carne...)"
                      value={
                        item.observacao
                      }
                      onChange={(e) =>
                        atualizarObservacao(
                          item.id_item,
                          e.target.value
                        )
                      }
                    />
                  </div>
                ))}
              </div>
            )}

            {/* Forma de Pagamento */}
            <div
              className={
                styles.pagamentoSecao
              }
            >
              <h4>
                Forma de Pagamento
              </h4>

              <div
                className={
                  styles.pagamentoOpcoes
                }
              >
                {[
                  'Dinheiro',
                  'Cartão',
                  'PIX'
                ].map((opcao) => (
                  <button
                    key={opcao}
                    className={`${
                      styles.pagamentoBtn
                    } ${
                      formaPagamento ===
                      opcao
                        ? styles.pagamentoSelecionado
                        : ''
                    }`}
                    onClick={() =>
                      setFormaPagamento(
                        opcao
                      )
                    }
                  >
                    <span>
                      {opcao}
                    </span>
                  </button>
                ))}
              </div>
            </div>

            {/* Total e Botão */}
            <div
              className={
                styles.carrinhoFooter
              }
            >
              <div
                className={
                  styles.carrinhoTotal
                }
              >
                <span>Total</span>

                <span>
                  R${' '}
                  {totalCarrinho.toFixed(
                    2
                  )}
                </span>
              </div>

              <button
                className={
                  styles.btnCriarPedido
                }
                onClick={criarPedido}
                disabled={
                  loading ||
                  carrinho.length ===
                    0 ||
                  !formaPagamento
                }
              >
                {loading
                  ? 'Criando...'
                  : 'Criar Pedido'}
              </button>
            </div>
          </div>
        </div>
      )}

      {/* Barra flutuante do carrinho */}
      {!carrinhoAberto &&
        carrinho.length > 0 && (
          <div
            className={
              styles.resumoBar
            }
          >
            <div
              className={
                styles.resumoInfo
              }
            >
              <span>
                {totalItens}{' '}
                {totalItens === 1
                  ? 'item'
                  : 'itens'}{' '}
                · {mesaLabel}
              </span>

              <span
                className={
                  styles.resumoTotal
                }
              >
                R${' '}
                {totalCarrinho.toFixed(
                  2
                )}
              </span>
            </div>

            <button
              className={
                styles.resumoBtnEnviar
              }
              onClick={() =>
                setCarrinhoAberto(
                  true
                )
              }
            >
              Enviar Pedido

              <FiArrowRight
                size={18}
              />
            </button>
          </div>
        )}

      <FooterOpcoes typeView="equipe" />
    </div>
  );
}

export default NovoPedido;